import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  return (await response.json()) as T;
}

export interface HelpChatMessage {
  role: "user" | "assistant";
  content: string;
}

export interface HelpChatRequest {
  message: string;
  conversationHistory: HelpChatMessage[];
}

export interface HelpChatApiResponse {
  reply: string;
}

export function runHelpChat(
  payload: HelpChatRequest,
): Promise<HelpChatApiResponse> {
  return request<HelpChatApiResponse>("/api/ai/help/chat", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
